import { isContentMax, isMobile } from "components/utility/page-responsive/PageResponsive";
import { animateInfographic, animateInfographicHeadline } from "./animatedInfoHeadline";
import { animateMicroCap } from "./animateMicroCap";

const chooseHandler = (entry) => {
	if (entry.target.querySelector(".ddiff-animated-exhibit-infographic")) {
		const infographic = entry.target.querySelector(".ddiff-animated-exhibit-infographic");

		if (entry.isIntersecting && isContentMax()) {
			animateInfographic(infographic);
		}
		if (entry.isIntersecting && !isMobile()) {
			animateInfographicHeadline(infographic, false);
			microCapObserver.unobserve(entry.target);
		}
	}

	if (entry.target.querySelector(".ddiff-micro-cap-chart")) {
		if (entry.isIntersecting && !isMobile()) {
			animateMicroCap(entry);
			microCapObserver.unobserve(entry.target);
		}
	}
};

const microCapObserver = new IntersectionObserver(
	(entries) =>
		entries.forEach((entry) => {
			chooseHandler(entry);
		}),
	{
		root: null,
		rootMargin: `0px 0px -25% 0px`,
		threshold: 0
	}
);

export const observeMicroCap = () => {
	const microCapElements = document.querySelectorAll(".ddiff-micro-cap-wrapper");
	microCapElements.forEach((element) => {
		if (element) {
			microCapObserver.observe(element);
		}
	});
};

export const microCapObserverDisconnect = () => {
	microCapObserver.disconnect();
};
